import React from "react";
import "../../css/TarjetaDestacada.css";
import { Link } from "react-router-dom";
import img from "../../img/pareja.JPEG";

const TarjetaDestacada = () => {
    return (
        <div className="tarjeta-destacada">
            <div className="tarjeta-contenido">
                <h4 className="tarjeta-titulo">El mejor plan es el que hacemos juntos.</h4>
                <Link to="/galeria" className="tarjeta-boton">Ver recuerdos</Link>
            </div>
            <img src={img} alt="Sorpresa" className="tarjeta-imagen" />
        </div>
    );
};

// -------------------------------
/* IDEAS */
// -------------------------------
// 🧡 Opción 1: Mensaje romántico rotativo o especial
// Contenido:

// "Nuestro próximo viaje te está esperando…"
// Imagen: una playa, maleta o brújula
// Botón: "Ver destinos"
// -------------------------------
// 🎁 Opción 2: Sorpresa del día
// Contenido:

// "¿Preparado para la sorpresa de hoy?"
// Imagen: una caja de regalo
// Botón: "Descúbrela"
// -------------------------------
// 🍝 Opción 3: Receta destacada del día
// Contenido:

// "Hoy cocinamos algo especial"
// Imagen: una receta tuya
// Botón: "Ver receta"
// -------------------------------
// 💬 Opción 4: Frase o cita personalizada
// Contenido:

// "El mejor plan es el que hacemos juntos"
// Imagen: una ilustración de pareja
// Botón: "Ver ideas"
// -------------------------------

export default TarjetaDestacada;
